/* --------------------------------------------------------------------------------------
   printBrowse.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const printBrowseComponent = {
  template: `
    <div class="main-container">
      <div class="content-container" ng-show="vm.node">
        <action-bar id="print-browse-action-bar" title="{{ 'BROWSE' | translate }}" ok="vm.ok()" cancel="vm.cancel()" disable-ok="!vm.selected.length"></action-bar>
        <browser search-enabled="true" node="vm.node" matter="vm.matter" selection-type="file" selected="vm.selected"></browser>
      </div>
    </div>
    `,
  controllerAs: "vm",
  controller: class printBrowseCtrl {
    /* @ngInject */
    constructor(sessionDataService, $state) {
      this.sessionDataService = sessionDataService;
      this.$state = $state;
    }
    ok() {
      this.sessionDataService.selectedFiles = this.selected;
      this.sessionDataService.matter = this.matter;
      this.$state.go("printSettings");
    }
    cancel() {
      this.$state.go(this.sessionDataService.lastOp);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/print/components/printBrowse.component.js